import { defineMessages } from 'react-intl';

export default defineMessages({
  goBack: 'Go back',
  connect: 'Connect',
});
